import { cx } from '#core/gen/css';
import type { BoxProps } from '#core/gen/jsx';
import { Box } from '#core/gen/jsx';

import styles from './Loader.module.css';

type LoaderProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
} & BoxProps;

export const Loader = ({ size = 'md', className, ...rest }: LoaderProps) => {
  return (
    <Box className={cx(styles.loader, styles[size], className)} {...rest}>
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </Box>
  );
};
